/**
 * Žeton iz povezave v e-pošti ({@code …#žeton}): v delu za # ostane v brskalniku in ne pride v dnevnike strežnikov
 * (HAProxy, pm2 serve).
 */
export function zetonIzPovezave(): string {
  return decodeURIComponent(window.location.hash.replace(/^#/, ''));
}
